import BaseView from '../../base-view';
import Collection from './collection';
import ListItemView from './item/view';

/**
 * Base view for real time lists on admin dasboard
 **/
export default BaseView.extend({

	// can be extended / overriden
	events: {},

	/**
	 * list constructor
	 * takes bootstrapped data for collection as parameter
	 **/
	initialize: function(collectionData) {
		// create collection with bootstrapped data
		this.collection = new Collection(collectionData || []);

		// listen to collection changes
		this.listenTo(this.collection, 'add', this.onNotificationAdded);
		this.listenTo(this.collection, 'remove', this.onNotificationRemoved);

		// reference elements
		this.listEl = this.query('.js-list');
	},

	/**
	 * render list based on models in collection
	 * returns the list
	 **/
	renderList: function() {
		// nothing to render
		if (this.collection.length === 0) {
			return;
		}

		var fragment = document.createDocumentFragment(),
			listItem;

		this.collection.forEach(function(model) {
			// create item and add to fragment
			listItem = this.renderListItem(model);
			fragment.appendChild(listItem.el);
		}, this);

		// add fragment to dom
		this.listEl.appendChild(fragment);

		return this.listEl;
	},

	/**
	 * add list item to the list
	 * returns created list item view
	 **/
	addListItem: function(model) {
		var listItem = this.renderListItem(model);

		this.listEl.insertBefore(listItem.el, this.listEl.firstChild);

		return listItem;
	},

	/**
	 * render a single list item
	 * returns created list item view
	 **/
	renderListItem: function(model) {
		return new ListItemView({
			model: model
		}).render();
	},

	/**
	 * new notification handler
	 * adds new model to the collection
	 **/
	onNotificationReceived: function(data) {
		this.collection.add(data);
	},

	/**
	 * notification removed handler
	 * can be overriden
	 **/
	onNotificationRemoved: function() {},

	/**
	 * notification added to collection handler
	 * adds new list item to the list and returns the list item view
	 **/
	onNotificationAdded: function(model, collection) {
		var listItem = this.addListItem(model);
		listItem.el.classList.add('is-new');

		return listItem;
	},

	render: function() {
		// render the list
		this.renderList();

		return this;
	}
});
